// extracted by mini-css-extract-plugin
export default {"mobileFooterContainer":"MobileFooterMenu_mobileFooterContainer__6Ittv","button":"MobileFooterMenu_button__FbaK2","activeButton":"MobileFooterMenu_activeButton__Y2Q-o"};